import { ContactApi, ToastStateHandler } from '../../../api';
import { ContactDto } from '../../../commonTypes/client.types';
import { dispatch } from '../../../store';
import { deleteContact } from '../../../store/slices/clients.slice';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const useHttpDeleteContact = () => {
    const { t } = useTranslation('newNotifications');
    const contactApi: ContactApi = useContainer(ContactApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const execDelete = (contact: ContactDto, callback: () => void) => {
        const { exec, abort } = contactApi.delete({
            params: { clientId: contact.clientId, id: contact.id },
            onSuccess: _ => {
                dispatch(deleteContact({ contact }));
                callback();
                return toastHandler.push('success', t('contact.deleteContactTitle'), t('contact.deleteContactMessage_Success'));
            },
            onError: _ => {
                toastHandler.push('error', t('contact.deleteContactTitle'), t('contact.deleteContactMessage_Failed'));
            },
        });
        exec();
        return abort;
    };

    return { execDelete };
};

export default useHttpDeleteContact;
